var parent = require('../../../es/string/virtual');

module.exports = parent;
